import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle, FiCheck } from 'react-icons/fi';

const PainStory = () => {
  const benefits = [
    'More freedom.',
    'More peace of mind.',
    'And less financial pressure.'
  ];

  return (
    <SalesLetterWrapper>
      <div className="space-y-8">
        <h2 className="text-3xl md:text-4xl font-display font-black text-brand-dark">
          Retirement Was Supposed To Feel Easier…
        </h2>
        
        <p className="text-2xl font-bold text-brand-gold">Instead…</p>
        
        <p>For many retirees, it feels more financially stressful than expected.</p>
        
        <div className="space-y-4 border-l-4 border-brand-gold/20 pl-6 py-2 italic font-medium text-brand-dark">
          <p>Groceries cost more.</p>
          <p>Fuel costs more.</p>
          <p>Insurance costs more.</p>
          <p>Travel costs more.</p>
        </div>

        <p>And suddenly the retirement income that once felt comfortable…</p>
        <p className="text-2xl font-black text-brand-dark">…doesn’t stretch nearly as far as it used to.</p>

        <p className="text-text-secondary">Maybe you’ve felt it too.</p>
        <p className="text-text-secondary">That quiet stress in the background.</p>

        <div className="bg-white p-10 rounded-[2.5rem] shadow-premium border border-slate-100">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-3">
            <SafeIcon icon={FiAlertCircle} className="text-brand-gold" />
            The feeling of needing:
          </h3>
          <ul className="space-y-4 text-xl">
            <li className="flex items-center gap-4">
              <span className="w-2 h-2 bg-brand-gold rounded-full"></span>
              A little more breathing room
            </li>
            <li className="flex items-center gap-4">
              <span className="w-2 h-2 bg-brand-gold rounded-full"></span>
              More flexibility
            </li>
            <li className="flex items-center gap-4">
              <span className="w-2 h-2 bg-brand-gold rounded-full"></span>
              And more financial confidence in retirement
            </li>
          </ul>
        </div>

        <div className="space-y-6 pt-6">
          <p>Not because you want to become rich.</p>
          <p>Not because you want to build a giant business.</p>
          <p className="text-2xl font-display font-black text-brand-dark leading-tight">
            But simply because: <span className="text-brand-gold">you want more options.</span>
          </p>
          
          <div className="space-y-4 pt-4">
            {benefits.map((text, i) => (
              <div key={i} className="flex items-center gap-4 group">
                <div className="flex-shrink-0 w-8 h-8 bg-brand-green/10 rounded-full flex items-center justify-center text-brand-green">
                  <SafeIcon icon={FiCheck} className="text-xl font-black" />
                </div>
                <p className="text-2xl font-display font-black text-brand-dark group-hover:text-brand-green transition-colors">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default PainStory;